import { ReactElement, useContext } from 'react';
import cms from '../../data/cms.json';
import { Title } from '../Title/Title';
import { Paragraph } from '../Paragraph/Paragraph';
import { Button } from '../Button/Button';
import { AppContext } from '../../context/AppContext';
import { unlockScroll } from '../../utils/bodyScrollLock';
import styles from './ConfirmBackPopup.module.scss';
import { getDataTest } from '../../utils/dataTests';

export interface ConfirmBackPopupProps {
    onClickMoveToSave: () => void;
    onClickContinueWithoutSave: () => void;
}

export const ConfirmBackPopup = ({
    onClickMoveToSave,
    onClickContinueWithoutSave,
    ...props
}: ConfirmBackPopupProps): ReactElement | null => {
    const ctx = useContext(AppContext);

    return (
        <div className={styles.confirmBackPopup} {...props}>
            <Title tag="h1" className="mb-4" data-title={getDataTest(props, 'Title')}>
                {cms.common.YourChangesAreNotSaveTitle}
            </Title>

            <Paragraph data-title={getDataTest(props, 'Text')}>{cms.common.blockingUnsavedChangeText}</Paragraph>

            <Button
                className={'mb-4'}
                variant="primary"
                onClick={() => {
                    unlockScroll();

                    ctx.setPopupVisible(false);
                    ctx.setPopupContentVariables(null);
                    onClickMoveToSave();
                }}
                data-title="moveToSaveButton"
            >
                {cms.common.moveToSaveButton}
            </Button>

            <a
                onClick={(e) => {
                    e.preventDefault();
                    ctx.setNavigationLocked(false);
                    ctx.setPopupVisible(false);
                    unlockScroll();
                    onClickContinueWithoutSave();
                }}
                className={styles.continueWithoutSaveButton}
                href="#"
                data-title="continueWithoutSaveButton"
            >
                {cms.common.continueWithoutSaveButton}
            </a>
        </div>
    );
};
